import { useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { ChromeContext, type ChromeContextValue } from "./ChromeContext";
import styles from "./Layout.module.css";
import { Rail } from "./Rail";
import { RouteBoundary } from "./RouteBoundary";
import { Toasts } from "./Toasts";
import { TopBar } from "./TopBar";
import { useGlobalKeys } from "./useGlobalKeys";
import { CheatSheet } from "../palette/CheatSheet";
import { CommandPalette } from "../palette/CommandPalette";
import { useActiveRepoId, useNav } from "../routing/useNav";

export const Layout = () => {
  const { pathname } = useLocation();
  const nav = useNav();
  const activeRepoId = useActiveRepoId();
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [cheatOpen, setCheatOpen] = useState(false);

  const chrome = useMemo<ChromeContextValue>(
    () => ({
      openCheat: () => setCheatOpen(true),
      openPalette: () => setPaletteOpen(true),
    }),
    [],
  );

  const keyHandlers = useMemo(
    () => ({
      goHome: () => nav.dashboard(),
      goSettings: () => nav.settings(),
      newAgent: () => nav.newAgent(activeRepoId),
      toggleCheat: () => setCheatOpen((c) => !c),
      togglePalette: () => setPaletteOpen((p) => !p),
    }),
    [activeRepoId, nav],
  );
  useGlobalKeys(keyHandlers);

  return (
    <ChromeContext.Provider value={chrome}>
      <div className={styles.app}>
        <div className="paper-grain" />
        <TopBar />
        <div className={styles.main}>
          <Rail />
          <main className={styles.content}>
            <div className={styles.routeWrap}>
              <RouteBoundary key={pathname}>
                <Outlet />
              </RouteBoundary>
            </div>
          </main>
        </div>
      </div>

      {paletteOpen ? (
        <CommandPalette onClose={() => setPaletteOpen(false)} />
      ) : null}
      {cheatOpen ? <CheatSheet onClose={() => setCheatOpen(false)} /> : null}
      <Toasts />
    </ChromeContext.Provider>
  );
};
